// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_payment-links_btn-primary__1CT6M","label":"_payment-links_label___qhjE","select":"_payment-links_select__t8nAE"};